export type Locale = "en" | "sv";
export const allLocales: Locale[] = ["en", "sv"];
export type LocaleNamespace = "common" | "phishing" | "tasks";
export type LocaleMessages = Record<string, unknown>;
export type LocaleNamespaceLoader = (
  locale: Locale,
  namespace: LocaleNamespace,
) => Promise<LocaleMessages>;
